import { officialServerClient } from '@/clientInstance';
import type { ILangAndCountry } from '@/interface/IApi';
// import * as C from '@/interface/IApi';
// import { oneTime } from '@/utils/shared';

export interface ICategoryResp {
    id: number;
    key: string;
    name: string;
    shortName: string;
    icon: string;
    link: string;
    description: string;
    note: string;
    parentId: number;
    image: {
        pc: string;
        mobile: string;
    };
    /**
     * 是否为正式产品分类
     */
    isNormal: boolean;
    /**
     * store页面排序
     */
    sort: number;
    /**
     * deal页面排序
     */
    dealSort: number;
}

// function wrapedLangAndCountryForGet<T>(url: string): (country: string) => Promise<T> {
//     return (country: string) => officialServer.get<T>(url + `&lang=${getCurrentLang()}&country=${country}`);
// }

// 根据产品的ID数组获取产品信息列表
// interface IGetProductListParams extends ILangAndCountry {
//     productIds: Array<string | number>;
// }

export interface IStoreProductCategory{
    id: number;
    key: string;
    name: string;
    second: Array<{
        id: number;
        key: string;
        name: string;
    }>;
}

export interface IStoreProductTag{
    id: number;
    name: string;
    priority: number;
    location: string;
    img: string;
}
export interface IStoreProductItem{
    id: number;
    key: string;
    name: string;
    categories: IStoreProductCategory[];
    href: string;
    image: {
        pc: string;
        mobile: string;
        scene: string;
        store: string;
        banner: string;
    };
    salePolicies: {
        sellable: boolean;
        deliverTips: string;
    };
    tags: IStoreProductTag[];
    profile: {
        description: string;
    };
    currency: {
        code: string;
        precision: number;
        symbol: string;
    };
    sort: number;
}
export interface IGetProductListResp {
    category: {
        id: number;
        description: string;
        icon: string;
        image: {
            mobile: string;
            pc: string;
        };
        key: string;
        link: string;
        name: string;
        shortName: string;
        note: string;
        /**
         * 是否为正式产品分类
         */
        isNormal: boolean;
    };
    products: IStoreProductItem[];
}
const getProductList = async ({ country, lang }: ILangAndCountry): Promise<IGetProductListResp[]> => {
    const result = await officialServerClient.get<{ items: IGetProductListResp[]; }>(`/store/product/list?lang=${lang}&country=${country}`);
    return result.items;
};

interface IGetStoreCategoryListArgs{
    country: string;
    lang: string;
    /**
     * 显示位置
     * default: store
     */
    show?: 'all'|'store';
    /**
     * 分类类型
     * all: 返回所有分类，normal: 返回正式产品分类，special: 返回非正式产品分类
     * default: all
     */
    type?: 'all' | 'normal'| 'special';
}

// 获取分类信息
const getCategoryList = async (args: IGetStoreCategoryListArgs): Promise<ICategoryResp[]> => {
    const result = await officialServerClient.get<{ items: ICategoryResp[]; }>(`/store/category/list?lang=${args.lang}&country=${args.country}${
        args.show ? `&show=${args.show}` : ''
    }${
        args.type ? `&type=${args.type}` : ''
    }`);
    return result.items;
};

export {
    getCategoryList,
    getProductList
};
